import React, { useCallback, useState, useRef } from 'react';
import { ModalIds, useModal } from "../../contexts/ModalContext";
import { Tooltip, useMediaQuery } from "@mui/material";
import { DialogContentStyled, DialogStyled } from "./modalComponent";
import { getOrientation } from 'get-orientation/browser'
import { ButtonStyled, CropBox, DeleteDocBox, GridBox, HrLine, InputUploadBox, InputUploadMoreFileBox, UploadFileEachDoc } from "../styledComponent/styledComponents";
import IconButton from "@mui/material/IconButton";
import ClearIcon from "@mui/icons-material/Clear";
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import DialogTitle from "@mui/material/DialogTitle";
import Stack from "@mui/material/Stack";
import Slider from "@mui/material/Slider";
import Typography from "@mui/material/Typography";
import TouchRipple from "@mui/material/ButtonBase/TouchRipple";
import UploadSvg from "../../assets/svgs/upload-svgs/uploadSvg";
import getCroppedImg, { getRotatedImage } from "../upload-file-components/react-image-crop/cropImage";
import Box from "@mui/material/Box";
import SelectFileSvg from "../../assets/svgs/upload-svgs/selectFileSvg";
import ImagePlaceHolderSvg from "../../assets/svgs/upload-svgs/imagePlaceHolderSvg";
import CropperComponent from "../upload-file-components/react-image-crop/CropperComponent";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { getDocsByType, uploadDocsRequest, useDeleteDocMutation, useGetUploadFileStatusesQuery } from "../../features/upload-documents/uploadDocumentSlice"
import UploadStatusEachDoc from '../upload-file-components/show-upload-file-status-components/uploadStatusEachDoc';

const ORIENTATION_TO_ANGLE = {
    '3': 180,
    '6': 90,
    '8': -90,
}

const ImageCropperModal = () => {
    const dispatch = useDispatch()
    const isSupports100dvh = window.CSS.supports('(min-height: 100dvh)');
   
    // const [uploadDoc, {data: result, isLoading, error}] = useUploadDocumentsMutation()
    const {refetch} = useGetUploadFileStatusesQuery();
    const [imageSrc, setImageSrc] = useState(null);
    const [imageSrcPreview, setImageSrcPreview] = useState('');
    const rippleRefZoomButton = useRef(null);
    const rippleRefRotateButton = useRef(null);
    const {handleClose, modalId, modalOption} = useModal();
    const matches = useMediaQuery('(min-width:200px) and (max-width:600px)');
    const [crop, setCrop] = useState({x: 0, y: 0});
    const [rotation, setRotation] = useState(0);
    const [zoom, setZoom] = useState(0.8);
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
    const [croppedImage, setCroppedImage] = useState(null);

    const uploadedDocs = useSelector(getDocsByType({type:modalOption?.type}))

    const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
        setCroppedAreaPixels(croppedAreaPixels)
    }, [])

    const showCroppedImage = useCallback(async () => {
        if (!imageSrc) return
        try {
            const croppedImageTarget = await getCroppedImg(
                imageSrc,
                croppedAreaPixels,
                rotation,
                zoom,
            )
            // setCroppedImage(croppedImageTarget)
            const targetFile = convertUrlToFile(croppedImageTarget ? croppedImageTarget : imageSrc)
            const formData = new FormData()
            formData.append('file', targetFile)
            formData.append('type', modalOption?.type)
            //call rtk request
            // uploadDoc(formData).unwrap().then(res=>console.log(res)).catch(err=>console.log(err))
            // uploadDoc(formData)
            dispatch(uploadDocsRequest({ formData, type: modalOption?.type }))
                .then(res => {
                    if (res?.payload?.data?.status === "success") {
                        refetch();
                    } else {
                        toast.error("upload file failed!")
                    }
                }).catch(err => {
                    toast.error(err.message)
                })

            modalOption?.type === "cheque" ? handleResetCropper() : handleCloseModal();
        } catch (e) {
            console.error(e)
        }

    }, [croppedAreaPixels, rotation, zoom])

    const onFileChange = async (e) => {
        if (e.target.files && e.target.files.length > 0) {
            setCroppedImage(null)
            setRotation(0)
            setZoom(0.8)
            let imageDataUrl;
            const file = e.target.files[0];
            if (file.size > (1 * 1024 * 1024)) {
                toast.error("حجم فایل ارسالی حداکثر ۱ مگابایت باشد");  
            } else if(file.type === 'image/png' || file.type === 'image/jpeg' || file.type === 'image/jpg') {
                imageDataUrl = await readFile(file);
            } else {
                toast.error("فرمت فایل غیر قابل قبول می باشد");
            }

            try {
                // apply rotation if needed
                const orientation = await getOrientation(file)
                const rotation = ORIENTATION_TO_ANGLE[orientation]
                if (rotation) {
                    imageDataUrl = await getRotatedImage(imageDataUrl, rotation)
                }
            } catch (e) {
                console.warn('failed to detect the orientation', e)
            }

            setImageSrc(imageDataUrl)
        }
    }

    const handleCloseModal = () => {
        handleClose()
        setImageSrc(null)
        setImageSrcPreview('')
        setSelectedDoc(null)
        setCroppedImage(null)
        setRotation(0)
        setZoom(0.8)
    }
    
    const handleResetCropper = () => {
        setImageSrc(null)
        setImageSrcPreview('')
        setSelectedDoc(null)
        setCroppedImage(null)
        setRotation(0)
        setZoom(0.8)
    }

    const [DeleteDoc] = useDeleteDocMutation();
    const [selectedDoc, setSelectedDoc] = useState({});
    const handleShowPreviewDoc = (doc) => {
        setImageSrcPreview(doc?.url);
        setSelectedDoc(doc);
    }
    const handleDeleteDoc = () => {
        DeleteDoc({ docId:selectedDoc?.id })?.unwrap().then(res => {
            if (res.success === true) {
                toast.success(res.secondaryMessage);
                setImageSrcPreview('');
            } else {
                toast.error(res.secondaryMessage);
            }
        }).catch(err => {
            console.log(err)
        })
    }


    return (
        <DialogStyled open={modalId === ModalIds.IMAGE_CROPPER_MODAL} onClose={handleCloseModal}
                      minWidth={!matches ? "550px" : "100vw"} width={480} height={!matches ? "800px" : "100%"}
                      minHeight={matches && (isSupports100dvh ? "100dvh" : "100vh")}>
            <DialogTitle sx={{
                padding: "12px 16px 8px 8px",
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between"
            }}>
                <Typography variant={"span"} fontSize={14}
                            color={"tertiary.main"}>بارگذاری {modalOption?.title_fa}</Typography>
                <IconButton size={"small"} color={"fourth"}>
                    <ClearIcon onClick={handleCloseModal}/>
                </IconButton>
            </DialogTitle>
            <HrLine/>
            <DialogContentStyled sx={{alignItems: "center"}}>
                {
                    imageSrc ? (
                            <CropperComponent
                                imageSrc={imageSrc}
                                crop={crop}
                                setCrop={setCrop}
                                onCropComplete={onCropComplete}
                                zoom={zoom}
                                setZoom={setZoom}
                                rotation={rotation}
                                setRotation={setRotation}/>
                        )
                        :
                        <CropBox borderStyle={!!imageSrcPreview}>
                            {
                                imageSrcPreview
                                    ? <>
                                        {
                                            (selectedDoc?.status !== "ok" && selectedDoc?.type === "cheque")
                                            && <Tooltip title={'حذف فایل'} placement='bottom' arrow={true}>
                                                <DeleteDocBox>
                                                    <IconButton size='medium' onClick={handleDeleteDoc}>
                                                        <DeleteOutlineIcon sx={{ color: "#FFF" }} />
                                                    </IconButton>
                                                </DeleteDocBox>
                                            </Tooltip>
                                        }
                                        <Stack justifyContent={'center'}>
                                            <img src={imageSrcPreview} style={{ objectFit: "contain", maxWidth: "100%", display: "block" }} width={'100%'} height={'100%'} />
                                        </Stack>
                                    </>
                                    : <>
                                        <ImagePlaceHolderSvg />
                                        <Typography fontSize={{ xs: 12, sm: 14, md: 16 }} color={'fourth.main'}>فایل مورد نظر خود را انتخاب
                                            کنید.</Typography>
                                    </>
                            }
                        </CropBox>
                }

                {
                    (!imageSrc) &&
                    <>
                        <GridBox showBorder={uploadedDocs?.length > 0 }>
                            {
                                uploadedDocs?.map((doc,index) => (
                                    // (doc.type === "cheque") &&
                                        <Stack alignItems={'center'} gap={0.5} key={doc.id}>
                                            {/* <UploadFileEachDoc pendingStyle={doc.status === "pend"} disabledEvents={doc.status === "pend" || doc.status === 'ok'}> */}
                                            <UploadFileEachDoc selectedDocStyle={doc.id === selectedDoc?.id} pendingStyle={doc.status === "pend"} onClick={() => handleShowPreviewDoc(doc)}>
                                                <img loading='lazy' src={doc.url} style={{ objectFit: "contain" }} width={100} height={100} alt={doc.type} />
                                            </UploadFileEachDoc>
                                            <Stack direction={'row'} justifyContent={"center"}>
                                                {
                                                    doc.status === "pend" ?
                                                        <Typography variant='caption' fontSize={12} color={'text.main'}>بررسی...</Typography>
                                                        :
                                                        <Stack direction={'row'} gap={0.5} alignItems={'center'}>
                                                            <Typography whiteSpace={"nowrap"} fontSize={12} color={"text.main"}>
                                                                شماره {index+1}
                                                            </Typography>
                                                            <UploadStatusEachDoc doc={doc} />
                                                        </Stack>
                                                }
                                            </Stack>
                                        </Stack>
                                    ))
                            }
                        </GridBox>
                        {
                            (modalOption?.type === "cheque" && uploadedDocs?.length > 0) &&
                            <Stack width={'100%'} direction={'row'} justifyContent={'flex-start'}>
                                <Box>
                                    <InputUploadBox show={!!imageSrc}>
                                        <input
                                            type="file"
                                            hidden
                                            id="upload"
                                            accept="image/*"
                                            onChange={onFileChange}
                                        />
                                        + افزودن تصاویر بیشتر
                                    </InputUploadBox>
                                </Box>
                            </Stack>
                        }
                    </>
                }
                <Stack width={'100%'} height={imageSrc && "100%"} justifyContent={"space-between"} alignItems={"flex-start"} px={{sm: 6}}>
                    {
                        imageSrc ?
                            <Stack width={{xs: '100%', sm: '98%'}} my={1} px={{xs: 1, sm: 0}} gap={{xs: 1, sm: 2}}>
                                <Stack direction={"row"} alignItems={'center'}
                                       gap={2}>
                                    <Typography
                                        onMouseDown={(e) => rippleRefZoomButton.current.start(e)}
                                        onMouseUp={(e) => rippleRefZoomButton.current.stop(e)}
                                        sx={{
                                            cursor: "pointer",
                                            position: 'relative',
                                            borderRadius: 2,
                                            paddingLeft: 1,
                                            whiteSpace: "nowrap"
                                        }}
                                        fontSize={14}
                                        color={"text.main"}>
                                        بزرگنمایی
                                        <TouchRipple ref={rippleRefZoomButton} center={false}/>
                                    </Typography>
                                    <Slider
                                        sx={{
                                            "& .MuiSlider-rail": {
                                                backgroundColor: "#cccccc",
                                                height: 3,
                                            },
                                            "& .MuiSlider-track": {
                                                height: 4,
                                            }
                                        }}
                                        color={'info'}
                                        size={"small"}
                                        aria-label="Zoom"
                                        aria-labelledby="Zoom"
                                        value={zoom}
                                        onChange={(e, zoom) => setZoom(zoom)}
                                        min={0.4}
                                        max={3}
                                        step={0.1}
                                    />
                                </Stack>
                                <Stack direction={"row"} alignItems={'center'}
                                       gap={3.2}>
                                    <Typography
                                        type="button"
                                        onMouseDown={(e) => rippleRefRotateButton.current.start(e)}
                                        onMouseUp={(e) => rippleRefRotateButton.current.stop(e)}
                                        sx={{
                                            cursor: "pointer",
                                            position: 'relative',
                                            borderRadius: 2,
                                            paddingLeft: 1,
                                            whiteSpace: "nowrap"
                                        }}
                                        fontSize={14}
                                        color={"text.main"}>
                                        چرخش
                                        <TouchRipple ref={rippleRefRotateButton} center={false}/>
                                    </Typography>
                                    <Slider
                                        sx={{
                                            "& .MuiSlider-rail": {
                                                backgroundColor: "#cccccc",
                                                height: 3,
                                            },
                                            "& .MuiSlider-track": {
                                                height: 4,
                                            }
                                        }}
                                        color={'info'}
                                        size={"small"}
                                        aria-label="Rotate"
                                        aria-labelledby="Rotation"
                                        value={rotation}
                                        onChange={(e, rotation) => setRotation(rotation)}
                                        min={0}
                                        max={180}
                                        step={1}
                                    />
                                </Stack>
                            </Stack>
                            : null
                    }
                    <Stack width={'100%'} direction={"row"} gap={2} mt={-2}>
                        {
                            imageSrc ?
                                <>
                                    <ButtonStyled
                                        onClick={showCroppedImage}
                                        width={"93%"}
                                        gap={14}
                                        height={48}
                                        startIcon={<UploadSvg color={"#FFF"} />}
                                        variant="contained">
                                        بارگذاری
                                    </ButtonStyled>
                                    <Box width={"100%"}>
                                        <InputUploadMoreFileBox show={!!imageSrc}>
                                            <input
                                                type="file"
                                                hidden
                                                id="upload"
                                                accept="image/*"
                                                onChange={onFileChange}
                                            />
                                            <SelectFileSvg show={!!imageSrc} />
                                            انتخاب فایل
                                        </InputUploadMoreFileBox>
                                    </Box>
                                </>
                                : (modalOption?.type === "cheque" && uploadedDocs?.length > 0)
                                    ? <ButtonStyled
                                        onClick={() => handleCloseModal()}
                                        width={'100%'}
                                        gap={14}
                                        height={48}
                                        variant="contained">
                                        تایید
                                    </ButtonStyled>
                                    : <Box width={"100%"}>
                                        <InputUploadMoreFileBox show={!!imageSrc}>
                                            <input
                                                type="file"
                                                hidden
                                                id="upload"
                                                accept="image/*"
                                                onChange={onFileChange}
                                            />
                                            <SelectFileSvg show={!!imageSrc} />
                                            انتخاب فایل
                                        </InputUploadMoreFileBox>
                                    </Box>
                            
                        }
                        
                    </Stack>
                </Stack>
            </DialogContentStyled>
        </DialogStyled>
    );


    function readFile(file) {
        return new Promise((resolve) => {
            const reader = new FileReader()
            reader.addEventListener('load', () => resolve(reader.result), false)
            reader.readAsDataURL(file)
        })
    }

    function convertUrlToFile(url) {
        if (!url) return;
        let arr = url?.split(',')
        let mime = arr[0]?.match(/:(.*?);/)[1]
        let data = arr[1]
        let dataStr = atob(data)
        let n = dataStr.length
        let dataArr = new Uint8Array(n)
        while (n--) {
            dataArr[n] = dataStr.charCodeAt(n)
        }
        return new File([dataArr], `${modalOption?.type}_file.jpg`, {type: mime});
    }
};

export default ImageCropperModal;